import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ChevronDown, ChevronLeft, ChevronRight } from 'lucide-react';
import { RosadoPromo } from './RosadoPromo';
import { NegroPromo } from './NegroPromo';
export function Products() {
  const [expandedRosado, setExpandedRosado] = useState(false);
  const [expandedNegro, setExpandedNegro] = useState(false);
  const [rosadoImageIndex, setRosadoImageIndex] = useState(0);
  const [negroImageIndex, setNegroImageIndex] = useState(0);
  const rosadoImages = ['https://cdn.magicpatterns.com/uploads/wq6YXJAr6hdYgGtddAmQq2/ChatGPT_Image_20_abr_2026,_20_08_07.png', 'https://cdn.magicpatterns.com/uploads/fWALG8H619iKDk6xyKSDsJ/d6f6b1d7-7906-4849-9b0b-dc5ea9cc688d.jpg', 'https://cdn.magicpatterns.com/uploads/uPfBUfT2hUtyDL8fWtXdWE/ChatGPT_Image_20_abr_2026,_20_07_24.png', 'https://cdn.magicpatterns.com/uploads/7W27e3K4woAXVtoifegPKg/4497e3b6-c0e6-4929-acb0-fe381dad099e.jpg', 'https://cdn.magicpatterns.com/uploads/8ysrASFbWq8yb2Zw8e4wVz/92520652-d6ae-41d4-a9b7-bc6974ef76e5.jpg', 'https://cdn.magicpatterns.com/uploads/wtyLJRm6gaTAuHmKCZaKjf/0D8CC461-27A2-4BAA-BC23-CABB4DFA6045.png'];
  const negroImages = ['https://cdn.magicpatterns.com/uploads/7yFwuHrde9f4MrWQZW9sUK/ChatGPT_Image_20_abr_2026,_20_08_20.png', 'https://cdn.magicpatterns.com/uploads/hrhNm58zU1nucXYAfoSFMa/ChatGPT_Image_20_abr_2026,_20_04_57.png', 'https://cdn.magicpatterns.com/uploads/xoVRRCVj4e1ur15p81n3bi/110A8423-A3E2-411B-83EE-B09C7DD1FBDA_(1).png', 'https://cdn.magicpatterns.com/uploads/tsV5i4YR5v7GKqnbdcoe2p/fa2f9a63-2c6d-44b6-aa45-3fdf25e9746a.jpg', 'https://cdn.magicpatterns.com/uploads/7Nnr2e2uuGKDNHDsGGZ61U/6e02a688-b463-4266-931d-04d88ee12b51.jpg'];
  return <section className="py-24 px-6 bg-white" id="products" data-id="element-166">
      <div className="max-w-6xl mx-auto" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-168">
          <h2 className="text-3xl md:text-4xl font-serif text-luxury-black mb-4" data-id="element-169">
            ELIGE TU FAVORITO
          </h2>
          <div className="w-16 h-0.5 bg-gold mx-auto" data-id="element-170"></div>
        </motion.div>

        <div className="flex flex-col gap-12 lg:gap-16" data-id="element-171">
          {/* KIT ROSADO — PROTAGONISTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="group relative bg-rosado-soft rounded-2xl p-8 md:p-12 border border-rosado-light/30 hover:shadow-xl transition-shadow duration-500 flex flex-col max-w-2xl mx-auto w-full" data-id="element-172">
            <div className="absolute top-6 right-6 bg-white text-rosado font-bold text-xs tracking-wider uppercase px-3 py-1.5 rounded-full shadow-sm flex items-center gap-1 z-10" data-id="element-173">
              🔥 MÁS VENDIDO
            </div>

            {/* Image Gallery */}
            <div className="relative aspect-[3/2] sm:aspect-[4/3] bg-white rounded-xl mb-6 overflow-hidden -mx-2 md:-mx-4" data-id="element-174">
              <img src={rosadoImages[rosadoImageIndex]} alt="Kit Rosado Premium" loading="eager" decoding="async" className="w-full h-full object-cover transition-opacity duration-300" style={{
              imageRendering: 'auto',
              WebkitBackfaceVisibility: 'hidden'
            }} data-id="element-175" />
              {/* Navigation arrows */}
              <button onClick={() => setRosadoImageIndex(prev => prev === 0 ? rosadoImages.length - 1 : prev - 1)} className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-white/80 hover:bg-white rounded-full flex items-center justify-center shadow-sm transition-colors" data-id="element-176">
                <ChevronLeft className="w-4 h-4 text-luxury-black" data-id="element-177" />
              </button>
              <button onClick={() => setRosadoImageIndex(prev => prev === rosadoImages.length - 1 ? 0 : prev + 1)} className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-white/80 hover:bg-white rounded-full flex items-center justify-center shadow-sm transition-colors" data-id="element-178">
                <ChevronRight className="w-4 h-4 text-luxury-black" data-id="element-179" />
              </button>
              {/* Dots */}
              <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5" data-id="element-180">
                {rosadoImages.map((_, i) => <button key={i} onClick={() => setRosadoImageIndex(i)} className={`w-2 h-2 rounded-full transition-colors ${i === rosadoImageIndex ? 'bg-rosado' : 'bg-white/60'}`} data-id="element-181" />)}
              </div>
            </div>

            <h3 className="text-2xl font-serif text-luxury-black mb-3" data-id="element-182">
              KIT ROSADO PREMIUM
            </h3>
            <p className="text-gray-600 font-sans font-light mb-6" data-id="element-183">
              Elegancia, organización y estilo en un solo beauty kit diseñado
              para mujeres que aman verse profesionales siempre.
            </p>

            <ul className="space-y-2.5 mb-6" data-id="element-184">
              {['Fácil de usar', 'Compacto y portátil', 'Ideal para citas, estudio o viajes', 'Perfecto para profesionales y principiantes', 'Diseño femenino y sofisticado', 'Acabado premium elegante'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-gray-700" data-id="element-185">
                  <Check className="w-5 h-5 text-rosado shrink-0" data-id="element-186" />
                  <span data-id="element-187">{item}</span>
                </li>)}
            </ul>

            <p className="font-serif italic text-luxury-black text-center mb-6 text-sm" data-id="element-188">
              Todo en orden. Todo contigo.
            </p>

            <button className="w-full bg-rosado hover:bg-rosado-light text-white font-sans font-medium tracking-widest uppercase py-4 rounded-sm transition-colors duration-300" data-id="element-189">
              COMPRAR KIT ROSADO
            </button>

            <p className="text-center text-xs text-gray-400 mt-3 tracking-wide" data-id="element-190">
              ✨ Ideal para regalar
            </p>

            <button onClick={() => setExpandedRosado(!expandedRosado)} className="mt-6 flex items-center justify-center gap-2 w-full text-sm font-medium text-gray-500 hover:text-rosado transition-colors uppercase tracking-wider" data-id="element-191">
              {expandedRosado ? 'Ocultar detalles' : 'Ver detalles'}
              <motion.div animate={{
              rotate: expandedRosado ? 180 : 0
            }} data-id="element-192">
                <ChevronDown className="w-4 h-4" data-id="element-193" />
              </motion.div>
            </button>

            <AnimatePresence data-id="element-194">
              {expandedRosado && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.4,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-195">
                  <div className="pt-8 mt-6 border-t border-rosado-light/30" data-id="element-196">
                    <h4 className="font-serif text-lg text-luxury-black mb-4" data-id="element-197">
                      TU ESENCIAL DE BELLEZA, ORGANIZADO CON ESTILO
                    </h4>

                    <div className="space-y-4 text-sm text-gray-600 font-light mb-8" data-id="element-198">
                      <p data-id="element-199">
                        Diseñado para mujeres que aman los detalles, la
                        organización y una imagen impecable. Este beauty travel
                        kit combina elegancia, practicidad y comodidad para
                        acompañarte a donde vayas.
                      </p>
                      <p data-id="element-200">
                        Ideal tanto para profesionales como para principiantes
                        que desean tener sus herramientas siempre listas y en
                        orden.
                      </p>
                    </div>

                    <div className="mb-8" data-id="element-201">
                      <h5 className="text-xs font-bold tracking-widest uppercase text-rosado mb-4" data-id="element-202">
                        DETALLES DEL PRODUCTO:
                      </h5>
                      <ul className="space-y-2 pl-1" data-id="element-203">
                        {['Incluye 8 esenciales beauty items', 'Tono universal', 'No sensible al calor', 'Libre de crueldad animal', 'No caduca', 'Presentación tipo estuche / kit / cosmetiquera'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-204">
                            <span className="w-1.5 h-1.5 rounded-full bg-rosado shrink-0 mt-1.5" data-id="element-205"></span>
                            <span data-id="element-206">{item}</span>
                          </li>)}
                      </ul>
                    </div>

                    <div className="mb-8 bg-white/60 p-4 rounded-lg border border-rosado-light/20" data-id="element-207">
                      <p className="text-xs font-bold uppercase text-luxury-black mb-1" data-id="element-208">
                        IMPORTANTE:
                      </p>
                      <p className="text-sm text-gray-600" data-id="element-209">
                        Solo para uso externo.
                      </p>
                    </div>

                    <button className="w-full bg-luxury-black hover:bg-luxury-dark text-white font-sans font-medium tracking-widest uppercase py-4 rounded-sm transition-colors duration-300 mb-6" data-id="element-210">
                      COMPRAR KIT ROSADO
                    </button>

                    <p className="text-center font-serif italic text-gray-500 text-sm" data-id="element-211">
                      Femenino, elegante y práctico para acompañarte siempre.
                    </p>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>

          {/* Rosado Promo Section */}
          <RosadoPromo data-id="element-212" />

          {/* Separator */}
          <div className="flex items-center gap-4 max-w-xs mx-auto" data-id="element-213">
            <div className="flex-1 h-px bg-gray-200" data-id="element-214"></div>
            <span className="text-xs tracking-[0.2em] uppercase text-gray-400 font-medium" data-id="element-215">
              o elige
            </span>
            <div className="flex-1 h-px bg-gray-200" data-id="element-216"></div>
          </div>

          {/* KIT NEGRO — ALTERNATIVA PREMIUM */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="group relative bg-luxury-black text-white rounded-2xl p-8 md:p-12 border border-luxury-dark hover:shadow-2xl transition-shadow duration-500 flex flex-col max-w-2xl mx-auto w-full" data-id="element-217">
            <div className="absolute top-6 right-6 bg-gold text-luxury-black font-bold text-xs tracking-wider uppercase px-3 py-1.5 rounded-full shadow-sm flex items-center gap-1 z-10" data-id="element-218">
              💎 PREMIUM QUALITY
            </div>

            {/* Image Gallery */}
            <div className="relative aspect-[3/2] sm:aspect-[4/3] bg-luxury-dark/50 rounded-xl mb-6 -mx-2 md:-mx-4 overflow-hidden" data-id="element-219">
              <img src={negroImages[negroImageIndex]} alt="Kit Negro Luxury" loading="eager" decoding="async" className="w-full h-full object-cover transition-opacity duration-300" style={{
              imageRendering: 'auto',
              WebkitBackfaceVisibility: 'hidden'
            }} data-id="element-220" />
              <button onClick={() => setNegroImageIndex(prev => prev === 0 ? negroImages.length - 1 : prev - 1)} className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-black/60 hover:bg-black/80 rounded-full flex items-center justify-center shadow-sm transition-colors" data-id="element-221">
                <ChevronLeft className="w-4 h-4 text-white" data-id="element-222" />
              </button>
              <button onClick={() => setNegroImageIndex(prev => prev === negroImages.length - 1 ? 0 : prev + 1)} className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-black/60 hover:bg-black/80 rounded-full flex items-center justify-center shadow-sm transition-colors" data-id="element-223">
                <ChevronRight className="w-4 h-4 text-white" data-id="element-224" />
              </button>
              <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5" data-id="element-225">
                {negroImages.map((_, i) => <button key={i} onClick={() => setNegroImageIndex(i)} className={`w-2 h-2 rounded-full transition-colors ${i === negroImageIndex ? 'bg-gold' : 'bg-white/40'}`} data-id="element-226" />)}
              </div>
            </div>

            <h3 className="text-2xl font-serif text-white mb-3" data-id="element-227">
              KIT NEGRO LUXURY
            </h3>
            <p className="text-gray-300 font-sans font-light mb-6" data-id="element-228">
              Organizado. Elegante. Profesional. El beauty kit diseñado para
              mujeres que buscan proyectar una imagen impecable, mantener todo
              en orden y llevar su estilo al siguiente nivel.
            </p>

            <ul className="space-y-2.5 mb-6" data-id="element-229">
              {['Todo en su lugar y fácil acceso', 'Diseño elegante y profesional', 'Ideal para citas, trabajo o viajes', 'Herramientas esenciales incluidas', 'Compacto, práctico y funcional', 'Perfecto para profesionales y principiantes'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-gray-300" data-id="element-230">
                  <Check className="w-5 h-5 text-gold shrink-0" data-id="element-231" />
                  <span data-id="element-232">{item}</span>
                </li>)}
            </ul>

            <p className="font-serif italic text-white text-center mb-6 text-sm" data-id="element-233">
              No es solo un kit. Es la forma profesional de llevar contigo todo
              lo que necesitas.
            </p>

            <button className="w-full bg-gold hover:bg-gold-dark text-luxury-black font-sans font-bold tracking-widest uppercase py-4 rounded-sm transition-colors duration-300" data-id="element-234">
              COMPRAR KIT NEGRO
            </button>

            <p className="text-center text-xs text-gray-400 mt-3 tracking-wide" data-id="element-235">
              ✨ Diseñado para mujeres que quieren verse y sentirse
              profesionales en todo momento.
            </p>

            <button onClick={() => setExpandedNegro(!expandedNegro)} className="mt-6 flex items-center justify-center gap-2 w-full text-sm font-medium text-gray-400 hover:text-gold transition-colors uppercase tracking-wider" data-id="element-236">
              {expandedNegro ? 'Ocultar detalles' : 'Ver detalles'}
              <motion.div animate={{
              rotate: expandedNegro ? 180 : 0
            }} data-id="element-237">
                <ChevronDown className="w-4 h-4" data-id="element-238" />
              </motion.div>
            </button>

            <AnimatePresence data-id="element-239">
              {expandedNegro && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.4,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-240">
                  <div className="pt-8 mt-6 border-t border-gray-800" data-id="element-241">
                    <h4 className="font-serif text-lg text-white mb-4" data-id="element-242">
                      ELEGANCIA PROFESIONAL EN CADA DETALLE
                    </h4>

                    <div className="space-y-4 text-sm text-gray-300 font-light mb-8" data-id="element-243">
                      <p data-id="element-244">
                        Pensado para mujeres y profesionales que buscan
                        presencia, orden y sofisticación. Este kit premium
                        ofrece funcionalidad total en un diseño moderno y
                        elegante.
                      </p>
                      <p data-id="element-245">
                        Perfecto para quienes desean proyectar una imagen
                        profesional mientras mantienen todo organizado.
                      </p>
                    </div>

                    <div className="mb-8" data-id="element-246">
                      <h5 className="text-xs font-bold tracking-widest uppercase text-gold mb-4" data-id="element-247">
                        DETALLES DEL PRODUCTO:
                      </h5>
                      <ul className="space-y-2 pl-1" data-id="element-248">
                        {['Incluye 8 esenciales cuidadosamente seleccionados', 'Organización inteligente para trabajar con mayor rapidez', 'Diseño pensado para elevar tu imagen profesional', 'Ideal para uso personal o en servicios de belleza', 'Material resistente que protege cada herramienta', 'Estuche premium con acabado elegante y duradero'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-300" data-id="element-249">
                            <span className="w-1.5 h-1.5 rounded-full bg-gold shrink-0 mt-1.5" data-id="element-250"></span>
                            <span data-id="element-251">{item}</span>
                          </li>)}
                      </ul>
                    </div>

                    <div className="mb-8 bg-luxury-dark/50 p-4 rounded-lg border border-gray-800" data-id="element-252">
                      <p className="text-xs font-bold uppercase text-gold mb-1" data-id="element-253">
                        IMPORTANTE:
                      </p>
                      <p className="text-sm text-gray-300" data-id="element-254">
                        Solo para uso externo.
                      </p>
                    </div>

                    <button className="w-full bg-gold hover:bg-gold-dark text-luxury-black font-sans font-bold tracking-widest uppercase py-4 rounded-sm transition-colors duration-300 mb-6" data-id="element-255">
                      COMPRAR KIT NEGRO
                    </button>

                    <p className="text-center font-serif italic text-gray-400 text-sm" data-id="element-256">
                      Sofisticado, práctico y diseñado para destacar.
                    </p>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>

          {/* Negro Promo Section */}
          <NegroPromo data-id="element-257" />
        </div>
      </div>
    </section>;
}